import BulmaTagsInput from '@creativebulma/bulma-tagsinput';
import '@creativebulma/bulma-tagsinput/dist/js/bulma-tagsinput.js'
import '@creativebulma/bulma-tagsinput/dist/css/bulma-tagsinput.css'

document.addEventListener("turbolinks:load", () => {
  BulmaTagsInput.attach();
});